var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "registor" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "login-box", attrs: { align: "center" } }, [
        _c("div", { staticClass: "main-text", attrs: { align: "center" } }, [
          _vm._v("\n                输入券码\n            "),
        ]),
        _vm._v(" "),
        _c("form", [
          _c("div", { staticClass: "form1" }, [
            _c("input", {
              staticClass: "user coupon-code",
              attrs: {
                type: "email",
                align: "center",
                placeholder: "请输入券码。",
              },
              on: { input: _vm.handleChangeCouponInput },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "wrong-text",
              domProps: { innerHTML: _vm._s(_vm.errorMessage) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "red-btn-popup" } }, [
            _c("input", {
              staticClass: "red-btn",
              attrs: { type: "button", value: "确认" },
              on: { click: _vm.handleRegisterClick },
            }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }